import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';

import { Box } from '@mui/material';

import { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';
import CurveComparisonSelector from '@/pages/Markets/MarketsComponents/Chart/ForwardCurveChartBlock/CurveComparisonSelector';
import { populateTemplates } from '@/pages/Markets/MarketsComponents/Chart/ForwardCurveChartBlock/populateTemplate';
import { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

const ButtonSection = ({
  chartSeries,
  templateChartSeries,
  comparisonTemplateSeries,
  setComparisonTemplateSeries
}: {
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
  templateChartSeries: TemplateChartSeries[] | undefined;
  comparisonTemplateSeries: TemplateChartSeries[];
  setComparisonTemplateSeries: Dispatch<SetStateAction<TemplateChartSeries[]>>;
}) => {
  const [transactionDates, setTransactionDates] = useState<string[]>([]);
  useEffect(() => {
    const templateTransactionDates: string[] = comparisonTemplateSeries
      ? comparisonTemplateSeries
          .map(template => template.symbol.transactionDate)
          .filter(value => value !== undefined)
          .reduce<string[]>((acc, curr) => (acc.includes(curr) ? acc : [...acc, curr]), [])
      : [];

    setTransactionDates(templateTransactionDates);
  }, [comparisonTemplateSeries]);

  const parseTransactionDatesToTemplates = useCallback(
    (transactionDatesStrings: string[]) => {
      if (templateChartSeries === undefined) return;
      const templates = transactionDatesStrings.flatMap(transactionDate =>
        populateTemplates(transactionDate, templateChartSeries)
      );
      setComparisonTemplateSeries(templates);
    },
    [setComparisonTemplateSeries, templateChartSeries]
  );

  const populateTemplateSeriesWith = useCallback(
    (selectedDateString: string, comparisonSelectorIndex: number) => {
      const newTransactionDates = [...transactionDates];
      newTransactionDates[comparisonSelectorIndex] = selectedDateString;
      parseTransactionDatesToTemplates(newTransactionDates);
    },
    [parseTransactionDatesToTemplates, transactionDates]
  );

  const deleteFromTemplateSeriesWith = useCallback(
    (comparisonSelectorIndex: number) => {
      const newTransactionDates = transactionDates.filter(
        (_, index) => index !== comparisonSelectorIndex
      );
      parseTransactionDatesToTemplates(newTransactionDates);
    },
    [parseTransactionDatesToTemplates, transactionDates]
  );

  return (
    <Box
      display='flex'
      mt={2}
    >
      <CurveComparisonSelector
        key={`comparisonSelector${1}`}
        chartSeries={chartSeries}
        comparisonSelectorIndex={0}
        deleteFromTemplateSeriesWith={deleteFromTemplateSeriesWith}
        label='Add date comparison'
        populateTemplateSeriesWith={populateTemplateSeriesWith}
        transactionDates={transactionDates}
      />
      {transactionDates.length > 0 && (
        <CurveComparisonSelector
          key={`comparisonSelector${2}`}
          chartSeries={chartSeries}
          comparisonSelectorIndex={1}
          deleteFromTemplateSeriesWith={deleteFromTemplateSeriesWith}
          label='Add date comparison'
          populateTemplateSeriesWith={populateTemplateSeriesWith}
          transactionDates={transactionDates}
        />
      )}
    </Box>
  );
};
export default ButtonSection;
